import { Helmet } from 'react-helmet-async';
import { SEO_ENABLED } from '../utils/seo';

export function SeoHead({ children, fallbackTitle = '220 km' }) {
  if (!SEO_ENABLED) {
    return (
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{fallbackTitle}</title>
      </Helmet>
    );
  }

  return <Helmet>{children}</Helmet>;
}
